export default {
    jobNotifications: (state) => (jobId) => {
        return state.notifications.filter(notification => notification.job_id === jobId)
    }
}
